<div class="bdo-container bdo-space--bottom">
  <h3>{{ 'siminvoice.title' | translate }}</h3>
</div>

<div class="bdo-container--single">
  <div class="re-container-with-margin re-mt-45 re-copytext">
    {{ 'siminvoice.description' | translate }}
  </div>
  @if (savingFailed) {
    <div class="bdo-container--single re-mt-30">
      <bdo-info-box>
        {{ 'siminvoice.error.general' | translate }}
      </bdo-info-box>
    </div>
  }
  <form [formGroup]="form" class="re-relative" [ngClass]="{'re-h-200 re-overflow-y-clip' : state === LoadingState.LOADING}" [attr.aria-label]="'aria.form.simulationInvoice' | translate">
    @if (state === LoadingState.LOADING) {
      <bdo-loading></bdo-loading>
    }
    <div class="re-container-with-margin re-mb-15 re-mt-45 md:re-mb-30 md:re-mt-60 re-ml-20 md:re-ml-auto">
      <h4>
        {{ 'siminvoice.period' | translate }}
      </h4>
    </div>
    <div class="re-bg-white re-w-full re-px-30 re-py-20 re-text
                md:re-w-600 md:re-mx-auto lg:re-w-900">
      <div class="re-form-item-container bdo-space--bottom bdo-space--top">
        <bdo-input
          formControlName="startpoint"
          [formControl]="$any(form.get('startpoint'))"
          [labelText]="'siminvoice.start' | translate"
        ></bdo-input>
        <div class="re-absolute re-right-0 re-top-0">
          <bdo-inline-tooltip [name]="'tooltip-startpoint'">
            {{ 'siminvoice.startTooltip' | translate }}
          </bdo-inline-tooltip>
        </div>
      </div>
      <div class="bdo-space--bottom re-form-item-container">{{ 'siminvoice.endHint' | translate:
        { minDate: minDateForChanges | date: 'dd.MM.yyyy', maxDate: maxDateForChanges | date: 'dd.MM.yyyy' } }}
      </div>
      <div class="re-form-item-container">
          <bdo-date-picker
            [selectedDate]="selectedDate"
            [minDateForChanges]="minDateForChanges"
            [maxDateForChanges]="maxDateForChanges"
            [labelText]=" 'siminvoice.end' | translate"
            (dateSelected)="onUpdateDate($event)"
          ></bdo-date-picker>
          <div class="re-absolute re-right-0 re-top-0">
            <bdo-inline-tooltip [name]="'tooltip-endpoint'">
              {{ 'siminvoice.endTooltip' | translate }}
            </bdo-inline-tooltip>
          </div>
      </div>
    </div>
    @for (division of divisions; track division) {
      <div class="re-container-with-margin re-mb-15 re-mt-45 md:re-mb-30 md:re-mt-60 re-ml-20 md:re-ml-auto">
        <h4>
          {{ 'general.tariff.meterWithDivision' | translate: { division: division | verbrauchstyp } }}
        </h4>
      </div>
      @for (meter of meters; track meter) {
        <div class="re-mb-20 md:re-mb-30">
          @if (meter.sparte === division) {
            <bdo-siminvoice-meter-readings
              [meter]="meter"
              [selectedDate]="selectedDate <= nowDate ? selectedDate : nowDate"
              [invalidText]="invalidText"
              [minDateForChanges]="minDateForChanges"
              [maxDateForChanges]="maxDateForChanges"
              (validEvent)="missingReading($event, meter)">
            </bdo-siminvoice-meter-readings>
          }
        </div>
      }
    }
    <div class="re-mt-45  re-pl-15 md:re-mt-60 md:re-pl-0">
      @if (state === LoadingState.LOADING) {
        <bdo-loading></bdo-loading>
      }
      @if (invalidText && hasMissingReading) {
        <div class="re-mb-20">
          <bdo-info-box [type]="'error'">
            {{ 'siminvoice.missingReadingError' | translate }}
          </bdo-info-box>
        </div>
      }
      <button class="re-button re-primary" (click)="calculate()" type="submit">
        {{ 'siminvoice.buttonSubmit' | translate }}
      </button>
      <div class="re-pt-15">
        <bdo-text-icon [iconPosition]="'left'"
          [text]="'dashboard.linkTo' | translate"
          (click)="toDashboard()">
        </bdo-text-icon>
      </div>
    </div>
  </form>
</div>

<!-- Overlay -->
@if (savingDone) {
  <bdo-simple-text-popup [isVisible]="savingDone" [icon]="'success'" [title]="'siminvoice.saved' | translate" [isManuallyClosable]="false">
    <div class="info--text re-mb-20">
      {{ 'siminvoice.savedDescription' | translate }}
    </div>
    <div class="link">
      <bdo-text-link-icon
        [linkText]="'documents.linkTo' | translate"
        [routerUrl]="'/dokumente/' + getKundennummer()"
        [iconPosition]="'right'"
        [tracking]="[TRACKING.LOCATION.SIMINVOICE_SUCCESS, TRACKING.ACTION.GOTO, TRACKING.LOCATION.DOCUMENTS]">
      </bdo-text-link-icon>
    </div>
  </bdo-simple-text-popup>
}

<!-- FAQs -->
<bdo-faqs [keyName]="'siminvoice.faqs'" [params]="{ contactLink: reBaseData.hrefContact }"></bdo-faqs>
